export default {
    admin: "Admin",
    crmUser: "CrmUser",
    merchandiser: "Merchandiser",
    supervisor: "Supervisor",
    nationalSupervisor: "NationalSupervisor",
    accountManager: "AccountManager",
    hr: "HR",

    customer: "Customer"
};
